import { render } from "./OrderUpdateAccount.vue?vue&type=template&id=7365c329&scoped=true"
import script from "./OrderUpdateAccount.vue?vue&type=script&lang=js"
export * from "./OrderUpdateAccount.vue?vue&type=script&lang=js"

import "./OrderUpdateAccount.vue?vue&type=style&index=0&id=7365c329&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7365c329"]])

export default __exports__